<template>
    <div>
        <app-sub-title text="Filtros" />
        <b-row>
            <b-col cols="12" md="4">
                <app-form-text-input 
                    v-model="filters.code"
                    placeholder="Codigo"
                />
            </b-col>
            <b-col cols="12" md="4">
                <app-form-text-input 
                    v-model="filters.name"
                    placeholder="Nombre creador"
                />
            </b-col>
            <b-col cols="12" md="4">
                <b-button variant="primary" class="mr-2 btn-block-xs-only" @click="$emit('filter', filters)"><i class="fa fa-filter"></i> Filtrar</b-button>
                <b-button variant="secondary" class="btn-block-xs-only" @click="clearFilters"><i class="fa fa-times-circle"></i> Reiniciar</b-button>
            </b-col>
        </b-row>
    </div>
</template>
<script>
export default {
    data(){
        return {
            filters: {
                code: '',
                name: ''
            }
        }
    },
    methods: {
        clearFilters(){
            Object.keys(this.filters).map(key => this.filters[key] = '');
            this.$emit('filter', null);
        }
    }
}
</script>

